import { render, staticRenderFns } from "./sidebar.vue?vue&type=template&id=1f24bbef&scoped=true&"
import script from "./sidebar.vue?vue&type=script&lang=js&"
export * from "./sidebar.vue?vue&type=script&lang=js&"
import style0 from "./sidebar.vue?vue&type=style&index=0&id=1f24bbef&prod&lang=scss&scoped=true&"
import style1 from "./sidebar.vue?vue&type=style&index=1&id=1f24bbef&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f24bbef",
  null
  
)

export default component.exports